export default __webpack_public_path__ + "static/media/headerRTAB.53de9a03.jpg";